<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-sm-12">
				<router-link :to="{ name: 'Dashboard Lessons' }">
					{{ 'Back to Lessons' | translate }}
				</router-link>
			</div>
			<div v-if="loading" class="text-center col-12">
				<i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
				<span class="sr-only">Loading...</span>
			</div>
			<div v-else class="col-sm-12">
				<form class="form-horizontal">
					<div class="tabs">
						<button
							v-for="language in languages"
							:key="language"
							@click.prevent="tab = language"
							:class="{ active: tab === language }"
							class="btn"
						>
							{{ language.toUpperCase() | translate }}
						</button>
					</div>
					<div class="tab-content">
						<div class="row form-group">
							<div class="col-sm-12 col-md-1">
								<input
									:disabled="!isSuper"
									type="number"
									class="form-control"
									v-model="order"
								/>
							</div>
							<div class="col-sm-12 col-md-11">
								<input
									v-for="language in languages"
									:key="language"
									:disabled="!isSuper"
									class="form-control"
									v-show="tab === language"
									v-model="name[language]"
								/>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-sm-12 col-md-12">
								<vue-editor
									v-for="language in languages"
									:key="language"
									:id="`editor-${language}`"
									:editorToolbar="toolbar"
									v-show="tab === language"
									:disabled="!isSuper"
									v-model="body[language]"
								/>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-sm-12">
							<input
								v-if="isSuper"
								@click.prevent="editLesson"
								type="submit"
								:value="'Edit' | translate"
								class="btn btn-primary"
							/>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
	components: { VueEditor },
	data() {
		return {
			id: null,
			loading: true,
			order: null,
			languages: [
				'en',
				'ru',
				'ua',
				'pl',
				'he',
				'ro',
				'az',
				'hy',
				'fr',
				'es',
				'cs',
				'de',
				'it',
				'tr',
				'el',
			],
			name: {
				en: null,
				ru: null,
				ua: null,
				pl: null,
				he: null,
				az: null,
				ro: null,
				hy: null,
				fr: null,
				es: null,
				cs: null,
				de: null,
				it: null,
				tr: null,
				el: null,
			},
			body: {
				en: null,
				ru: null,
				ua: null,
				pl: null,
				he: null,
				az: null,
				ro: null,
				fr: null,
				es: null,
				de: null,
				it: null,
				tr: null,
				el: null,
			},
			tab: 'ru',
			isSuper: this.$store.state.myProfile.role === 'super franchise',
			toolbar: [
				['bold', 'italic', 'underline', 'strike'],
				['blockquote', 'code-block', 'image', 'video'],
				[{ list: 'ordered' }, { list: 'bullet' }],
				[{ indent: '+1' }, { indent: '-1' }],
				[{ header: [1, 2, 3, 4, 5, 6, false] }],
				[{ color: [] }],
				[{ font: [] }],
				[{ align: [] }],
			],
		}
	},
	methods: {
		editLesson() {
			// console.log('Franch Test', this.name.fr, this.body.fr)

			this.axios({
				method: 'patch',
				url: `lessons/${this.$route.params.id}`,
				data: {
					id: this.id,
					name_en: this.name.en,
					name_ru: this.name.ru,
					name_uk: this.name.ua,
					name_pl: this.name.pl,
					name_he: this.name.he,
					name_az: this.name.az,
					name_ro: this.name.ro,
					name_hy: this.name.hy,
					name_fr: this.name.fr,
					name_es: this.name.es,
					name_cs: this.name.cs,
					name_de: this.name.de,
					name_it: this.name.it,
					name_tr: this.name.tr,
					name_el: this.name.el,

					body_en: this.body.en,
					body_ru: this.body.ru,
					body_uk: this.body.ua,
					body_pl: this.body.pl,
					body_he: this.body.he,
					body_az: this.body.az,
					body_ro: this.body.ro,
					body_hy: this.body.hy,
					body_fr: this.body.fr,
					body_es: this.body.es,
					body_cs: this.body.cs,
					body_de: this.body.de,
					body_it: this.body.it,
					body_tr: this.body.tr,
					body_el: this.body.el,

					order: this.order,
					is_active: true,
				},
			}).then(data => {
				this.$router.push({ name: 'Dashboard Lessons' })
			})
		},
		updateLesson() {
			this.axios({
				method: 'get',
				url: `lessons/${this.$route.params.id}`,
			}).then(({ data }) => {
				this.name = {
					en: data.name_en,
					ru: data.name_ru,
					ua: data.name_uk,
					pl: data.name_pl,
					he: data.name_he,
					az: data.name_az,
					ro: data.name_ro,
					hy: data.name_hy,
					fr: data.name_fr,
					es: data.name_es,
					cs: data.name_cs,
					de: data.name_de,
					it: data.name_it,
					tr: data.name_tr,
					el: data.name_el,
				}

				this.body = {
					en: data.body_en,
					ru: data.body_ru,
					ua: data.body_uk,
					pl: data.body_pl,
					he: data.body_he,
					az: data.body_az,
					ro: data.body_ro,
					hy: data.body_hy,
					fr: data.body_fr,
					es: data.body_es,
					cs: data.body_cs,
					de: data.body_de,
					it: data.body_it,
					tr: data.body_tr,
					el: data.body_el,
				}
				this.order = data.order
				this.id = data.id
				this.loading = false
			})
		},
	},
	computed: {
		isDisabledButton() {
			return (
				this.name.en &&
				this.name.ru &&
				this.name.ua &&
				this.name.pl &&
				this.name.he &&
				this.name.az &&
				this.name.ro &&
				this.name.hy &&
				this.name.fr &&
				this.name.es &&
				this.name.cs &&
				this.name.de &&
				this.name.it &&
				this.name.tr &&
				this.name.el &&
				this.body.ru &&
				this.body.ua &&
				this.body.pl &&
				this.body.he &&
				this.body.az &&
				this.body.ro &&
				this.body.hy &&
				this.body.fr &&
				this.body.es &&
				this.body.cs &&
				this.body.de &&
				this.body.it &&
				this.body.tr &&
				this.body.el
			)
		},
	},
	beforeMount() {
		this.updateLesson()
	},
}
</script>

<style scoped>
.nav-pills li {
	margin: 10px;
}

.submit {
	margin-top: 20px;
	margin-bottom: 20px;
}

.nav-pills {
	flex-wrap: wrap;
}

nav {
	margin: 50px auto;
}

.tabs .btn {
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0;
}

.tabs .active {
	background-color: #fff;
}

.tab-content {
	border: 1px solid buttonface;
	border-radius: 10px;
	border-top-right-radius: 0;
	border-top-left-radius: 0;
	background: #fff;
	padding: 30px;
	margin-bottom: 10px;
}
</style>
